function getEnv(): 'development' | 'staging' | 'production' {
  if (process.env.NODE_ENV === 'development') return 'development'
  if (location.hostname.includes('stage')) return 'staging'
  return 'production'
}

function getDomain(): 'atelier' | 'dresscode' | 'showoff' {
  const host = location.hostname
  const atelier = host.endsWith('.atelierdigital.ai') || host.endsWith('.apiresq.com')
  const dresscode = host.endsWith('.dresscode.ai')
  if(development) return 'dresscode'
  return atelier ? 'atelier' : dresscode ? 'dresscode' : 'showoff'
}

function getLanguage(): 'en' | 'ru' {
  const query = new URLSearchParams(location.search)
  if (query.has('en')) return 'en'
  if (query.has('ru')) return 'ru'

  const ru = app_domain === 'dresscode'
  return ru ? 'ru' : 'en'
}

export function getAtelierHost(): string {
  return location.hostname.endsWith('.apiresq.com') ? 'apiresq.com' : 'atelierdigital.ai'
}

export function getShareHost(): string {
  const atelier = app_domain === 'atelier'
  const dresscode = app_domain === 'dresscode'
  if (!production) return 'https://share-stage.showoff.app'
  return atelier ? `https://share.${getAtelierHost()}` :
    dresscode ? 'https://share.dresscode.ai' : 'https://share.showoff.app'
}

const env = getEnv()

export const releaseName = process.env.RELEASE_NAME || 'unknown'
export const development = env === 'development'
export const staging = env === 'staging'
export const production = env === 'production'
export const app_domain = getDomain()
export const default_language = getLanguage()
